import React from 'react';
import { environment } from '@/environment';

interface IPublicImageProps extends React.HTMLAttributes<HTMLElement> {
  src: string;
  alt?: string;
  isExternalSrc?: boolean;
  useMask?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
  loading?: 'lazy' | 'eager';
}

export const PublicImage: React.FC<IPublicImageProps> = ({
  src,
  isExternalSrc = false,
  useMask = false,
  alt,
  className,
  style,
  fetchPriority,
  loading,
  ...htmlProps
}) => {
  const fullSrc = isExternalSrc
    ? src
    : `${environment.baseUrl}${src.startsWith('/') ? '' : '/'}${src}`;

  if (useMask) {
    return (
      <div
        role="img"
        aria-label={alt}
        className={className}
        style={{
          maskImage: `url(${fullSrc})`,
          WebkitMaskImage: `url(${fullSrc})`,
          ...style,
        }}
        {...htmlProps}
      />
    );
  }

  return (
    <img
      alt={alt}
      src={fullSrc}
      className={className}
      style={style}
      loading={loading}
      {...(fetchPriority && { fetchpriority: fetchPriority })}
      {...(htmlProps as React.ImgHTMLAttributes<HTMLImageElement>)}
    />
  );
};
